// Identical to MetaFileLinkMode on server side
export class MetaFileLink {
  public id: number;
  public url: string;
  public title: string;
  public sizeB: number;
  public mediaType: string;

  // only on front end
  public documentType: number;
  public progress?: number;
  public fileType?: number;
}

export enum MediaType {
  // These values must match the server side MediaType enum.
  Unknown = 0,
  Image = 1,
  Pdf = 2,
  Video = 3,
  Audio = 4,
  TextDocument = 5,
  Spreadsheet = 6,
  Presentation = 7,
}

//  http://roufid.com/javascript-check-file-image/
function isImage(document: MetaFileLink) {
  return document && document.mediaType.split('/')[0] === 'image';
}

function isVideo(document: MetaFileLink) {
  return document && document.mediaType.split('/')[0] === 'video';
}

function isAudio(document: MetaFileLink) {
  return document && document.mediaType.split('/')[0] === 'audio';
}

function isPdf(document: MetaFileLink) {
  return document && document.mediaType.toLowerCase().indexOf('pdf') > -1;
}

/** Is document. Notice that PDF is also a document  */
function isTextDocument(document: MetaFileLink) {
  if (!document) {
    return false;
  }
  const acceptedTypes = [
    'msword',
    'application/pdf',
    'officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.text',
  ];

  for (const testedType of acceptedTypes) {
    if (document.mediaType.toLowerCase().includes(testedType)) {
      return true;
    }
  }
  return false;
}

function isSpreadsheet(document: MetaFileLink) {
  if (!document) {
    return false;
  }

  const acceptedTypes = [
    'text/x-csv',
    'application/vnd.ms-excel',
    'application/csv',
    'application/x-csv',
    'text/comma-separated-values',
    'text/x-comma-separated-values',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.oasis.opendocument.spreadsheet',
  ];

  for (const testedType of acceptedTypes) {
    if (document.mediaType.toLowerCase().includes(testedType)) {
      return true;
    }
  }
  return false;
}

function isPresentation(document: MetaFileLink) {
  if (!document) {
    return false;
  }
  const acceptedTypes = [
    'ms-powerpoint',
    'officedocument.presentationml.presentation',
    'application/vnd.ms-powerpoint',
    'application/vnd.oasis.opendocument.presentation',
  ];

  for (const testedType of acceptedTypes) {
    if (document.mediaType.toLowerCase().includes(testedType)) {
      return true;
    }
  }
  return false;
}

// tslint:disable-next-line:no-namespace
export namespace MetaFileLink {
  export function GetMediaType(document: MetaFileLink) {
    if (isImage(document)) {
      return MediaType.Image;
    } else if (isVideo(document)) {
      return MediaType.Video;
    } else if (isAudio(document)) {
      return MediaType.Audio;
    } else if (isPdf(document)) {
      return MediaType.Pdf;
    } else if (isTextDocument(document)) {
      return MediaType.TextDocument;
    } else if (isSpreadsheet(document)) {
      return MediaType.Spreadsheet;
    } else if (isPresentation(document)) {
      return MediaType.Presentation;
    } else {
      return MediaType.Unknown;
    }
  }
}

export default MetaFileLink;
